"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeEventProbabilitiesByMarketV3 = void 0;
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const _reduxjs_1 = require("../../../@reduxjs");
const getCategoryMarketInfoFilteredTradingStatus_1 = require("../getCategoryMarketInfoFilteredTradingStatus");
const isParameterValueMatching_1 = require("../isParameterValueMatching");
const getEventProbabilityByMarketKey_1 = require("../../getEventProbabilityByMarketKey");
const constants_1 = require("../../constants");
const getProbabilities_1 = require("./getProbabilities");
/*
Filter by status and parameter, to exclude sitation when we hav information about market with same id but difference parameters
*/
const findCorrectProbabilitiesByStatusAndParams = (probabilities, marketParameters) => {
    return probabilities.filter((probability) => !constants_1.EVENT_PROBABILITY_EXCLUDE_TRADING_STATUSES.includes(probability.tradingStatus) &&
        marketParameters.every((marketParameter) => probability.parameters.some((pParameter) => (0, isParameterValueMatching_1.isParameterValueMatching)(pParameter, marketParameter))));
};
const computeEventProbabilitiesByMarketV3 = ({ eventId, sportId, eventStatus, eventMarkets, eventCompetitors, 
// common data
virtualCategories, virtualMarketInfosMap, marketsMap, 
// event outcomes cache
eventProbabilitiesByVirtualMarket, virtualCategoriesInfos, playersMap, clientType, }) => {
    const marketKeys = new Set();
    const changedMarkets = {};
    const prevEventProbsByMarket = eventProbabilitiesByVirtualMarket !== null && eventProbabilitiesByVirtualMarket !== void 0 ? eventProbabilitiesByVirtualMarket : {};
    const prevMarketCategoriesInfos = virtualCategoriesInfos !== null && virtualCategoriesInfos !== void 0 ? virtualCategoriesInfos : [];
    const virtualCategoriesInfosMap = {};
    eventMarkets.forEach(({ marketId, probabilities: marketProbabilities }) => {
        var _a, _b, _c;
        const categoryInfos = (_a = virtualMarketInfosMap[marketId]) !== null && _a !== void 0 ? _a : [];
        const orderedOutcomeTypes = (_c = (_b = marketsMap[marketId]) === null || _b === void 0 ? void 0 : _b.orderedOutcomeTypes) !== null && _c !== void 0 ? _c : [];
        const outcomesTypesMap = (0, _reduxjs_1.toIdsMap)(orderedOutcomeTypes);
        categoryInfos.forEach(({ market, category }) => {
            if (!category.sportIds.includes(sportId)) {
                // We must filter by sport id due to eventMarket can have market id that can belongs to category that doesn't belong to event sport
                return;
            }
            // Filter probabilities according to parameters matching
            const tradingProbabilities = findCorrectProbabilitiesByStatusAndParams(marketProbabilities, market.filteredBy.parameters);
            if (!tradingProbabilities.length) {
                return;
            }
            const virtualCategoryId = category.id;
            const virtualMarketId = market.id;
            // Computing key
            const key = (0, getEventProbabilityByMarketKey_1.getEventProbabilityByMarketKey)({
                marketId,
                categoryMarketInfoId: virtualMarketId,
            });
            // Add the key to the set of new keys
            marketKeys.add(key);
            const probabilities = (0, getProbabilities_1.getProbabilities)(tradingProbabilities, market, orderedOutcomeTypes, outcomesTypesMap, playersMap, eventCompetitors, clientType);
            const newEventProbabilitiesByMarket = {
                eventId,
                virtualCategoryId,
                marketId,
                virtualMarketId,
                probabilities,
            };
            const prevEventProbabilitiesByMarket = prevEventProbsByMarket[key];
            if (!(0, react_fast_compare_1.default)(prevEventProbabilitiesByMarket, newEventProbabilitiesByMarket)) {
                changedMarkets[key] = newEventProbabilitiesByMarket;
            }
            const eventMarketCategoriesInfosValue = {
                ...market,
                tradingStatus: (0, getCategoryMarketInfoFilteredTradingStatus_1.getCategoryMarketInfoFilteredTradingStatus)({
                    probabilities,
                    eventStatus,
                }),
            };
            if (!virtualCategoriesInfosMap[virtualCategoryId]) {
                virtualCategoriesInfosMap[virtualCategoryId] = {
                    [virtualMarketId]: eventMarketCategoriesInfosValue,
                };
            }
            else {
                virtualCategoriesInfosMap[virtualCategoryId][virtualMarketId] =
                    eventMarketCategoriesInfosValue;
            }
        });
    });
    const prevKeys = Object.keys(prevEventProbsByMarket);
    const deletedMarkets = prevKeys.filter((key) => !marketKeys.has(key));
    const newMarketCategoriesInfos = virtualCategories.sortedIds.reduce((acc, virtualCategoryId) => {
        var _a, _b;
        const mci = virtualCategoriesInfosMap[virtualCategoryId];
        if (!mci) {
            return acc;
        }
        const orderedMarketIds = ((_a = virtualCategories.entries[virtualCategoryId]) === null || _a === void 0 ? void 0 : _a.orderedMarketsIds) || [];
        acc.push({
            categoryId: virtualCategoryId,
            categoryName: ((_b = virtualCategories.entries[virtualCategoryId]) === null || _b === void 0 ? void 0 : _b.name) || '',
            virtualMarkets: (0, _reduxjs_1.getValues)(orderedMarketIds, mci),
        });
        return acc;
    }, []);
    let changedCategoriesInfos;
    if (!(0, react_fast_compare_1.default)(prevMarketCategoriesInfos, newMarketCategoriesInfos)) {
        changedCategoriesInfos = newMarketCategoriesInfos;
    }
    return {
        changedMarkets,
        deletedMarkets,
        changedCategoriesInfos,
    };
};
exports.computeEventProbabilitiesByMarketV3 = computeEventProbabilitiesByMarketV3;
//# sourceMappingURL=computeEventProbabilitiesByMarketV3.js.map